// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kh","legalMessage":"ki","navLink":"kj","bottomLinkWrapper":"kk","bottomLink":"kl kj"};